module.exports = "<div class=\"dijitInline\"\n\t><a class=\"${baseClass}-value\" href=\"${href}\" data-dojo-attach-point=\"valueNode\"></a\n></div>"